{
  "title": "Painel",
  "welcome": "Bem-vindo de volta, {{name}}",
  "overview": {
    "title": "Visão Geral",
    "studentsActive": "Alunos Ativos",
    "lessonsCompleted": "Aulas Concluídas",
    "averageProgress": "Progresso Médio",
    "upcomingAssessments": "Próximas Avaliações"
  },
  "students": {
    "title": "Alunos",
    "add": "Adicionar Aluno",
    "search": "Pesquisar alunos...",
    "table": {
      "name": "Nome",
      "grade": "Série",
      "progress": "Progresso",
      "lastActive": "Última Atividade",
      "actions": "Ações"
    }
  },
  "curriculum": {
    "title": "Currículo",
    "subjects": "Matérias",
    "lessons": "Aulas",
    "assignments": "Tarefas",
    "assessments": "Avaliações"
  },
  "analytics": {
    "title": "Análises",
    "performance": "Desempenho",
    "engagement": "Engajamento",
    "completion": "Taxa de Conclusão",
    "timeSpent": "Tempo Gasto"
  },
  "notifications": {
    "title": "Notificações",
    "new": "Novas",
    "markAllRead": "Marcar todas como lidas",
    "noNotifications": "Sem novas notificações"
  }
}
